import config from 'config'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withStateHandlers, withHandlers, lifecycle, branch, renderComponent } from 'recompose'
import { push } from 'react-router-redux'
import * as UserSelectors from 'modules/user/selectors'
import { updateUserProperties } from 'modules/user/actions'
import { api } from 'modules/user/api'
import { updateOrgProperties } from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import { MeetingsStepWithPrime, AEMeetingsStepWithPrime } from './component'

import { track, page } from 'utils/trackingUtils'

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state),
  isRepInvitedFlow: UserSelectors.isRepInvitedFlow(state),
  isSSOProvisionedFlow: UserSelectors.isSSOProvisionedFlow(state),
  userId: UserSelectors.getUserId(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateUserProperties,
    updateOrgProperties,
    push
  }, dispatch),
})

const finishSetup = async(props) => {
  track('Onboarding Completed', {
    context: props.isCalendarSeat
      ? 'calendaring-seat-onboarding'
      : props.isRepInvitedFlow
      ? 'rep-onboarding'
      : 'sales-onboarding',
    isSSO: props.isSSOProvisionedFlow,
    shownExtension: false
  })

  if (props.isSSOProvisionedFlow) {
    props.actions.updateUserProperties({
      properties: {
        IS_JIT_PROVISIONED_USER: false,
      },
    })
  }
  if (props.isRepInvitedFlow) {
      await api.setAvailability(props.userId, 'AVAILABLE')
      window.location.replace(`${config.CUSTOMER_WEB_URL}/home`)
  }
  else {
    props.actions.updateOrgProperties({ properties: { signUpDone: true, onboardedDriftForSales: true }, redirect: true })
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Meetings Setup', {
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
        experiment: 'prime-and-two-skip'
      })
    }
  }),
  withStateHandlers(() => ({
    primed: false,
    triedSkipping: false,
    connectError: null,
  }),
  {
    setPrimed: () => (primed) => ({ primed }),
    skipFirst: () => () => ({ triedSkipping: true }),
    setConnectError: () => (connectError) => ({ connectError })
  }),
  withHandlers({
    onSkipClick: props => (e) => {
      if (window.chrome) {
        track('Onboarding Meetings Setup Completed', {
          context: props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
          method: 'skipped'
        })
        props.actions.push('/setup/extension')
      } else {
        e.preventDefault()
        finishSetup(props)
      }
    }
  }),
  branch(props => props.isCalendarSeat, renderComponent(AEMeetingsStepWithPrime))
)(MeetingsStepWithPrime)




// WEBPACK FOOTER //
// ./src/layouts/MeetingsStepWithPrime/index.js